import { render } from "./Video.vue?vue&type=template&id=3df9f004&scoped=true&ts=true"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"

import "./Video.vue?vue&type=style&index=0&id=3df9f004&lang=scss"
import "./Video.vue?vue&type=style&index=1&id=3df9f004&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df9f004"]])

export default __exports__